import axios from '../axios'

// モジュール削除（soft delete）
const deleteModuleApi = async (moduleId) => {
  return await axios.delete(`api/lms/modules/${moduleId}`)
}

export default deleteModuleApi
